import "./styles.css";
import { SyncrelStore } from "./data/syncrel-store";
import { accessModeFromUrl, mountApp, shouldStartReadOnlyFromUrl } from "./ui/app";
import { renderLandingPage } from "./ui/landing";

const root = document.querySelector<HTMLDivElement>("#app");

if (!root) {
  throw new Error("Missing #app root.");
}

const shouldRenderLandingPage = (): boolean => {
  const url = new URL(window.location.href);
  return !url.searchParams.has("room");
};

if (shouldRenderLandingPage()) {
  document.body.dataset.route = "landing";
  root.innerHTML = renderLandingPage();
} else {
  document.body.dataset.route = "app";
  root.innerHTML = `<main class="boot-screen"><div>Syncrel</div><span>initializing workspace</span></main>`;

  SyncrelStore.create(undefined, { readOnly: shouldStartReadOnlyFromUrl() })
    .then((store) => {
      store.setReadOnly(accessModeFromUrl(window.location.href, store.getState()) === "view");
      mountApp(root, store);
    })
    .catch((error: unknown) => {
      const message = error instanceof Error ? error.message : "Unknown startup error";
      root.innerHTML = `<main class="boot-screen boot-screen--error"><div>Syncrel</div><span>${message}</span></main>`;
    });
}
